import React, { useMemo } from "react";
import { useThemeMode } from '../../../context/contextTheme';
import { useTSContext } from '../../../context/Dashboard/contextTScore';
import './style.css';

const SecurityPosture = () => {
  const { theme } = useThemeMode();
  const {
    TSaveScore, THVulScore,
    TMVulScore, TLVulScore,
    hasScore
  } = useTSContext();
  
  return (
    <div className="p-2 pb-0 mb-3">
      <div
        className="card rounded-4 shadow-sm w-100"
        style={{
          minWidth: 300, maxWidth: 360,
          height: 'auto',
          minHeight: 206,
          backgroundColor: theme.background,
          border: `1px solid ${theme.border}`
        }}>
        <div className="card-body p-4">
          <h6 className="card-title fw-semibold mb-2"
            style={{
              fontSize: "20px",
              color: theme.textColor
            }}>
            Security Posture Score
          </h6>
          {!hasScore ? (
            <p className="small mt-4"
              style={{
                lineHeight: 1.5,
                color: theme.textMuted
              }}>
              Start initial scanning to detect security posture score.
            </p>
          ) : (
            <div className="mt-4 fs-6" style={{
              color: theme.textColor,
              lineHeight: 1.2
            }}>
              <div className="d-flex flex-row justify-content-between">
                <div className="pe-4">
                  <p className="mb-3 fw-semibold">Findings:</p>
                  <p className="mb-1">High: <span className="fw-semibold">{THVulScore}</span></p>
                  <p className="mb-1">Medium: <span className="fw-semibold">{TMVulScore}</span></p>
                  <p className="mb-1">Low: <span className="fw-semibold">{TLVulScore}</span></p>
                </div>
                <div className="pe-4 text-end">
                  <p className="badge bg-secondary">Score: </p>
                  <p className="fw-semibold fs-1">
                    {TSaveScore*10}/100
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div >
  );
};

export default SecurityPosture;
